import { useMemo } from 'react';
import { MenuNavigationShellPage } from '@/app/layout/MenuNavigationShellPage';
import type { AgendaRegistration } from '@/app/layout/MenuNavigationShellPage';
import { RESERVATIONS_BUSINESS_CASES } from './permissions';
import { businessCaseListAgenda, BusinessCaseListPage } from './businessCase';

export function ReservationsSlicePage() {
  const agendas: AgendaRegistration[] = useMemo(
    () => [
      {
        agenda: businessCaseListAgenda,
        component: BusinessCaseListPage,
        permission: RESERVATIONS_BUSINESS_CASES,
      },
    ],
    []
  );

  return <MenuNavigationShellPage agendas={agendas} rootAgenda={businessCaseListAgenda} />;
}
